import { createStore } from 'vuex';
import content from './modules/content';
import logs from './modules/logs';
import filterComponent from './modules/filterComponent';
import alerts from './modules/alerts';
import mailings from './modules/mailings';
import ui from './modules/ui';
import fileUploader from './modules/fileUploader';
import selectedDevices from './modules/selectedDevices';

const store = createStore({
    modules: {
        content,
        logs,
        filterComponent,
        alerts,
        mailings,
        ui,
        fileUploader,
        selectedDevices
    }
});

export default store;